import { useAppTheme } from '@/providers/theme-provider';
import Ionicons from '@expo/vector-icons/Ionicons';
import { router } from 'expo-router';
import { useState } from 'react';
import { Platform, TextInput, View } from 'react-native';

export function TopBarSearch() {
  const theme = useAppTheme();
  const [searchValue, setSearchValue] = useState('');

  const handleSubmit = () => {
    const trimmed = searchValue.trim();
    if (trimmed) {
      router.push({ pathname: '/(root)/search', params: { query: trimmed } });
      setSearchValue('');
    }
  };

  return (
    <View
      className="flex-row items-center rounded-full bg-surface"
      style={{ height: 36, width: 280, paddingHorizontal: 12 }}
    >
      <Ionicons
        name="search"
        size={16}
        className="text-muted-foreground"
        style={{ marginRight: 6 }}
      />
      <TextInput
        placeholder="Find a dish, restaurant, or friend"
        placeholderTextColor={theme.colors.textMuted}
        value={searchValue}
        onChangeText={setSearchValue}
        onSubmitEditing={handleSubmit}
        returnKeyType="search"
        style={{
          flex: 1,
          color: theme.colors.text,
          fontSize: 14,
          padding: 0,
          margin: 0,
          height: '100%',
          borderWidth: 0,
          ...(Platform.OS === 'web' && {
            outline: 'none',
            border: 'none',
            boxShadow: 'none',
            WebkitAppearance: 'none',
          }),
        }}
      />
    </View>
  );
}
